import { IBackgroundJobStarted } from '@models/backgroundJobs/IBackgroundJob';
import { FilesService } from '@services/FilesService';
import { BackgroundJobWaitStore } from '@services/backgroundJobs/awaitBackgroundJob';
import { BackgroundJobTask, createBackgroundJobTask } from '@services/backgroundJobs/backgroundJobTask';

export const ATTACHMENTS_ARCHIVE_KIND = 'attachmentsArchive';

export interface IAttachmentsArchiveTaskOptions {
    /** Прежняя синхронная выгрузка (GET): ею архив скачивается, когда фона нет (404 старта, 400 `runInBackground`). */
    syncUrl: string;
    /** Архив ушёл синхронной выгрузкой: окну ждать нечего. */
    onSyncDownload?: () => void;
    store?: BackgroundJobWaitStore;
}

const once = <T>(run: () => T): (() => T) => {
    let called = false;
    let value: T;
    return () => {
        if (!called) {
            called = true;
            value = run();
        }
        return value;
    };
};

/**
 * Архив вложений фоновой задачей `attachmentsArchive`; фона нет — прежней синхронной выгрузкой. Старт и синхронная
 * выгрузка — по разу на задачу: окно, начавшее ждать заново (повторный монтаж), ждёт тот же архив, а не второй.
 */
export const createAttachmentsArchiveTask = (
    start: () => Promise<IBackgroundJobStarted>,
    { syncUrl, onSyncDownload, store }: IAttachmentsArchiveTaskOptions,
): BackgroundJobTask => {
    const downloadSync = once(() => {
        FilesService.downloadFileNative(syncUrl);
        onSyncDownload?.();
    });
    return createBackgroundJobTask(once(start), {
        kind: ATTACHMENTS_ARCHIVE_KIND,
        store,
        resultActions: false,
        fallback: () => {
            downloadSync();
            return Promise.resolve({ success: true, message: '' });
        },
    });
};
